export default __webpack_public_path__ + "static/media/play button.758bae5f.png";